import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrencySymbol } from '../lib/currenyUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../index.css';
// import { CURRENCIES } from '../lib/currencies';
// import { currencyId } from '../lib/const/constants';
import {
  initiateWalletTransaction,
  beneficiaryList,
  fetchAndStoreLatestTransaction,
} from '../utils/CommonFunctions';
import TransactionHistory from './TransactionHistory';
import { ArrowRight } from 'lucide-react';
import { encryptPayload } from '../utils/encryption';

const Sendmoneyflow = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [receiveCurrency, setReceiveCurrency] = useState('');
  const [receiveCurrencyValue, setReceiveCurrencyValue] = useState('');
  const [countries, setCountries] = useState([]);
  const [loading] = useState(false);
  const [balLoading, setBalLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [type, settype] = useState('sell');

  const [convertloading, setConvertLoading] = useState(false);
  const [buyAmount, setBuyAmount] = useState('');
  const [exchangeRate, setexchangeRate] = useState(0);
  const [, setConvertDate] = useState('');
  const [contactId, setContactId] = useState('');
  const [, setrecentEdit] = useState();
  const [currency, setCurrency] = useState();
  const [currencyid, setCurrencyId] = useState();
  const [usedBalances, setusedBalances] = useState([]);
  const [clearBankBalance, setclearBankBalance] = useState(0.0);
  const [currencyCloudBalance, setcurrencyCloudBalance] = useState(0.0);
  const [balances, setBalances] = useState([]);
  const [recentLoaded, setRecentLoaded] = useState();
  const [clearBankConfiguration, setclearBankConfiguration] = useState();
  const [showproceed] = useState(true);
  const [, setreference] = useState();
  const [buyCurrency, setBuyCurrency] = useState();
  const [sellCurency, setSellCurrency] = useState();
  const timeout = useRef(null);
  const [kycPendingLater, setKycPendingLater] = useState(
    () => sessionStorage.getItem('kyc_pending_later') === 'true',
  );

  const [lastTransactions, setLastTransactions] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [editExchangeRate, setEditExchangeRate] = useState('');
  const staffLogin = sessionStorage.getItem('staff_login_id');
const isStaffAllowed = (Constants.STAFF_LOGIN_ID_CONVERSION || []).includes(
    staffLogin,
  );

  const [, setDropdownOpen] = useState(false);
  const [, setSelectedCurrency] = useState(null);
  const [receiveDropdownOpen, setReceiveDropdownOpen] = useState(false);
  const [selectedReceiveCurrency, setSelectedReceiveCurrency] = useState(null);
  const [displaySellCurrency, setDisplaySellCurrency] = useState('GBP');
  const [displayReceiveCurrency, setDisplayReceiveCurrency] = useState('INR');
  const [transferfee, setTransferfee] = useState();
  const [servicefee, setServicefee] = useState();
  const [txnsLoaded, setTxnsLoaded] = useState(false);
  const prefillDone = useRef(false);
  const dropdownStyle = {
    maxHeight: '200px',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    msOverflowStyle: 'auto',
    WebkitOverflowScrolling: 'touch',
  };


  const getCanonicalCountryId = (countryId) => {
    const duplicateMap = {
      182: 234,
      241: 234,
      11: 234,
      92: 234,
      149: 234,
      248: 1,
      188: 1,
      150: 1,
      26: 1,
      141: 1,
      180: 1,
      93: 21,
      145: 21,
      162: 21,
      205: 21,
      217: 21,
      41: 47,
      54: 13,
      163: 13,
    };
    return duplicateMap[countryId] ?? countryId;
  };
  console.log('Sell Currency', sellCurency);

  useEffect(() => {
    console.log(recentLoaded);
    setKycPendingLater(sessionStorage.getItem('kyc_pending_later') === 'true');
  }, [location.key]);

  useEffect(() => {
    
    getBalances();
    getData();
    removeData();
const backState = location.state;

    if (backState && backState.currencyid) {
      setCurrencyId(231);
      setCurrency(backState.from_currency || 'GBP');
      setReceiveCurrency(backState.currencyid);
      setReceiveCurrencyValue(backState.currency);
      setAmount(backState.amount || '');
      setBuyAmount(backState.buyAmount || '');
      setexchangeRate(backState.exchangeRate || 0);
      setContactId(backState.contactId || '');
      setTransferfee(backState.transfer_fee ?? '');
      setServicefee(backState.service_fee ?? '');
      prefillDone.current = true;
    } else {
      setDefaultCurrencies();
    }
  }, []);

  useEffect(() => {
if (!location.state?.currencyid || countries.length === 0) return;
    const match = countries.find((c) => c.id === location.state.currencyid);
    if (match) {
      setSelectedReceiveCurrency({
        currency: match.currency,
        currencyid: match.id,
        flag: getCountryFlagUrl(match),
      });
    }
  }, [countries]);

  useEffect(() => {
    fetchAndStoreLatestTransaction().then((txns) => {
      setLastTransactions(txns || []);
      setTxnsLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (prefillDone.current) return;
    if (!txnsLoaded) return;
    if (!currencyid) return;

    prefillDone.current = true;

    const lastSentTxn = Array.isArray(lastTransactions)
      ? lastTransactions.find((t) => t?.last_transaction?.type === 'debit')
      : null;

    if (lastSentTxn) {
      const conversionMeta = lastSentTxn?.meta_data?.conversion_meta;
      const sentAmount =
        conversionMeta?.conversion_client_sell_amount || lastSentTxn?.amount;

      if (sentAmount && parseFloat(sentAmount) >= 10) {
        const formattedAmount = parseFloat(sentAmount).toFixed(2);
        setAmount(formattedAmount);
        getConversionData(formattedAmount, receiveCurrency);
        return;
      }
    }

    // New user (no debit transactions) or amount below minimum → default 10 GBP
    setAmount('10.00');
    getConversionData('10.00', receiveCurrency);
  }, [txnsLoaded, currencyid, lastTransactions]);
  // }, [txnsLoaded, currencyid, lastTransactions, receiveCurrency]);

  useEffect(() => {
    const handleClickOutside = () => {
      setDropdownOpen(false);
      setReceiveDropdownOpen(false);
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const setDefaultCurrencies = () => {
    setCurrency('GBP');
    setCurrencyId(231);
    setReceiveCurrency(105);
    setReceiveCurrencyValue('INR');
  };

  const onChangeHandler = (value) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      getConversionData(value, receiveCurrency);
    }, 2000);
  };

  const getAvailableBalance = (currencyCode) => {
    const balanceObj = balances.find((b) => b.currency === currencyCode);
    if (!balanceObj) return 0;
    const used = usedBalances[currencyCode] || 0;
    const available = parseFloat(balanceObj.balance) - parseFloat(used);
    return available < 0 ? 0 : available;
  };

  const onInverseChangeHandler = (value) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      getInverseConversionData(value, receiveCurrency);
    }, 2000);
  };

  const getBalances = async () => {
    setBalLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL +
        'API-FX-231-GET-WALLET-BALANCES/' +
        login_workspaces_id,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const balArray = Object.values(resp.data);
      setusedBalances(resp.data.used_balances);
      balArray.pop();
      setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
      setclearBankBalance(resp.data.clear_bank_account_balance);
      setclearBankConfiguration(resp.data.fees_configuration);
      balArray.pop();
      balArray.pop();
      balArray.pop();
      console.log('clearbank' + clearBankBalance);
      console.log('currency' + currencyCloudBalance);
      console.log('clearBankConfiguration' + clearBankConfiguration);
      if (balArray.length > 0) {
        setBalances((balances) => [...balances, ...balArray]);
        console.log('balArray');
        if (balArray.length == 1) {
          balArray.push({
            id: 3,
            currency: 'INR',
            balance: 0,
            meta: {
              code: 'IN',
              name: 'India',
              country_id: 105,
              flag: 'https://uat.dhigna.com/flags/IN.PNG',
            },
            created_at: '2025-06-28T08:23:31.170932Z',
            updated_at: '2025-06-28T08:23:31.170935Z',
          });
        }
        const gbpMatch = balArray.find((b) => b.currency === 'GBP');
        if (gbpMatch && !location.state?.currencyid) {
          const flagUrl = getFlagUrl(gbpMatch);
          setSelectedCurrency({
            currency: gbpMatch.currency,
            currencyid: gbpMatch?.meta?.country_id,
            flag: flagUrl,
          });
        }
        const inrMatch = balArray.find((b) => b.currency === 'INR');
        if (inrMatch && !location.state?.currencyid) {
          const flagUrl = getFlagUrl(inrMatch);
          setSelectedReceiveCurrency({
            currency: inrMatch.currency,
            currencyid: inrMatch?.meta?.country_id,
            flag: flagUrl,
          });
        }
      } else {
        const defaultBank = sessionStorage.getItem('defaultBank');
const parsedWorkspace = JSON.parse(
          sessionStorage.getItem('login_workspaces'),
        );
        var ref = '';
        if (defaultBank === 'Clear Bank as Service') {
          console.log('cb');
        } else {
          if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
            console.log('cc');
          } else {
ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
              .memberships.urn;
            setreference(ref);
          }
        }
        if (ref != '') {
          setBalances(Constants.INDIVIDUAL_BALANCES_CURRENCIES);
        }
      }
      setBalLoading(false);
    } catch (err) {
      console.log(err.response.data);
      setBalLoading(false);
    } finally {
      setBalLoading(false);
    }
  };

  // const getData = async () => {
  //   settype('sell');
  //   const token = sessionStorage.getItem('login_token');
  //   const defaultBank = sessionStorage.getItem('defaultBank');
  //   const parsedWorkspace = JSON.parse(
  //     sessionStorage.getItem('login_workspaces'),
  //   );
  //   var ref = '';
  //   if (defaultBank === 'Clear Bank as Service') {
  //     console.log('cb');
  //   } else {
  //     if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
  //       console.log('cc');
  //     } else {
  //       ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
  //         .memberships.urn;
  //     }
  //   }
  //   if (ref == '') {
  //     await axios
  //       .get(Constants.BASE_URL + 'API-FX-162-CONVERTCOUNTRIES', {
  //         headers: {
  //           Authorization: 'Bearer ' + JSON.parse(token),
  //           fx_key: Constants.SUBSCRIPTION_KEY,
  //         },
  //       })
  //       .then((resp) => {
  //         setCountries(resp.data.buying_currencies);
  //       })
  //       .catch(() => {});
  //   } else {
  //     console.log('countries');
  //     setCountries(Constants.INDIVIDUAL_CURRENCIES);
  //   }
  // };
  const getData = async () => {
    settype('sell');
    const token = sessionStorage.getItem('login_token');
    const defaultBank = sessionStorage.getItem('defaultBank');
const parsedWorkspace = JSON.parse(
      sessionStorage.getItem('login_workspaces'),
    );
    var ref = '';
    if (defaultBank === 'Clear Bank as Service') {
      console.log('cb');
    } else {
      if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
        console.log('cc');
      } else {
ref = JSON.parse(sessionStorage.getItem('login_workspaces'))[0]
          .memberships.urn;
      }
    }
    console.log(ref);

    const INDIVIDUAL_CURRENCIES = await axios.get(
      Constants.BASE_URL + 'API-FX-247-GET-INDIVIDUAL-CURRENCIES',
      {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(token || '""'),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      },
    );

    setCountries(JSON.parse(INDIVIDUAL_CURRENCIES.data[0].currency_list).data);
  };

  const removeData = async () => {
    sessionStorage.removeItem('sell');
    sessionStorage.removeItem('buy');
  };

const getConversionData = async (
    amt,
    currencyReceive,
    sellCurrencyIdOverride,
  ) => {
    try {
      const token = sessionStorage.getItem('login_token');
      const staff_login_id = sessionStorage.getItem('staff_login_id');
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;
      if (!currencyReceive || !amt || amt == 0) {
        setConvertLoading(false);
        return;
      }
      if (amt < 10) {
        toast.error('Minimum Transfer Amount is 10 GBP');
        return;
      }
      setexchangeRate(0);
      setConvertLoading(true);
      let convertamount = amt || amount;
      if (activeSellCurrencyId === currencyReceive) {
        toast.error('Same currency cannot be converted.');
        setConvertLoading(false);
        return;
      }
      const encryptedPayload = await encryptPayload({
        sell_currency_country_id: activeSellCurrencyId,
        buy_currency_country_id: currencyReceive,
        amount: parseFloat(convertamount).toFixed(2),
        workspace_id: workspaceId,
        type: type,
        staff_login_id: staff_login_id,
        key_name: 'individual_transaction_fee',
        domain: 1,
        platform: 'web',
        extraParamValidation: 'trustedfromweb'
      });
      const response = await axios.post(
        Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );
      if (
        response.data &&
        response.data.code !== 400 &&
        response.data.success !== false
      ) {
        setRecentLoaded('normal');
        setAmount(
          parseFloat(response.data.data.meta.client_sell_amount).toFixed(2),
        );
        setBuyAmount(
          parseFloat(response.data.data.meta.client_buy_amount).toFixed(2),
        );
        setTransferfee(
          parseFloat(response.data.data.meta.individual_transaction_fee),
        );

        setexchangeRate(response.data.data.meta.client_rate);
        setEditExchangeRate('');
        const updatedate = new Date(response.data.data.updated_at);
        setConvertDate(
          `${updatedate.getDate()}-${updatedate.getMonth() + 1}-${updatedate.getFullYear()}`,
        );
        console.log('working contact_id from live conversion:', response.data.contact_id);
        setContactId(response.data.contact_id);
        setBuyCurrency(response.data.data.meta.client_buy_currency);
        setSellCurrency(response.data.data.meta.client_sell_currency);
        setDisplaySellCurrency(response.data.data.meta.client_sell_currency);
        setDisplayReceiveCurrency(response.data.data.meta.client_buy_currency);
      } else {
        toast.error(response.data.message || 'Rate could not be retrieved.');
      }
    } catch (error) {
      console.error('Error during getConversionData:', error);
      toast.error(error?.response?.data?.message || 'Error retrieving conversion rate.');
    } finally {
      setConvertLoading(false);
    }
  };

  const getCountryFlagUrl = (resp) => {
    switch (resp.currency) {
      case 'EUR':
        return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
      case 'RON':
        return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
      case 'DKK':
        return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
      case 'NOK':
        return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
      case 'SEK':
        return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
      case 'MYR':
        return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
      default:
        return `${Constants.FXMASTER_BASE_URL}flags/${resp?.code}.png`;
    }
  };


  const getInverseConversionData = async (amt, currencyReceive, sellCurrencyIdOverride) => {
    const token = sessionStorage.getItem('login_token');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;
    if (currencyReceive != '' && currencyReceive != null && amt != '' && amt != 0) {
      setConvertLoading(true);
      console.log(amt);
      var convertamount = amt;
      setBuyAmount(amt);
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      if (convertamount != '' && convertamount != null) {
        if (activeSellCurrencyId == currencyReceive) {
          toast.error('Same currency cannot be converted.');
          setConvertLoading(false);
          return;
        } else if (activeSellCurrencyId == 105) {
          toast.error('Currency not supported.');
          setConvertLoading(false);
          return;
        } else {
          setRecentLoaded('inverse');
          if (
            activeSellCurrencyId != '' && activeSellCurrencyId != null &&
            currencyReceive != '' && currencyReceive != null
          ) {
            try {
              const encryptedPayload = await encryptPayload({
                sell_currency_country_id: activeSellCurrencyId,
                buy_currency_country_id: currencyReceive,
                amount: parseFloat(convertamount).toFixed(2),
                workspace_id: workspaceId,
                type: 'buy',
                staff_login_id: staff_login_id,
                key_name: 'individual_transaction_fee',
                domain: 1,
                platform: 'web',
                extraParamValidation: 'trustedfromweb'
              });
              const resp = await axios.post(
                Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
                encryptedPayload,
                {
                  headers: {
                    fx_key: Constants.SUBSCRIPTION_KEY,
                    Authorization: 'Bearer ' + JSON.parse(token),
                  },
                },
              );
              if (resp.data.code != 400) {
                const sellamount = parseFloat(
                  resp.data.data.meta.client_sell_amount,
                ).toFixed(2);
                if (sellamount < 10) {
                  toast.error('Minimum transfer amount is 10 GBP');
                  setAmount('');
                  setBuyAmount('');
                  setexchangeRate(0);
                  setBuyCurrency('');
                  setSellCurrency('');
                  setContactId('');
                  setTransferfee('');
                  setServicefee('');
                  setConvertLoading(false);

                  return;
                }
                setBuyAmount(
                  parseFloat(resp.data.data.meta.client_buy_amount).toFixed(2),
                );
                setTransferfee(
                  parseFloat(resp.data.data.meta.individual_transaction_fee),
                );

                setAmount(
                  parseFloat(resp.data.data.meta.client_sell_amount).toFixed(2),
                );
                setexchangeRate(1 / resp.data.data.meta.client_rate);
                setEditExchangeRate('');
                setDisplaySellCurrency(resp.data.data.meta.client_sell_currency);
                setDisplayReceiveCurrency(resp.data.data.meta.client_buy_currency);
                const updatedate = new Date(resp.data.data.updated_at);
                setConvertDate(
                  updatedate.getDate() +
                  '-' +
                  (+updatedate.getMonth() + 1) +
                  '-' +
                  updatedate.getFullYear(),
                );
                setContactId(resp.data.contact_id);
                setBuyCurrency(resp.data.data.meta.client_buy_currency);
                setSellCurrency(resp.data.data.meta.client_sell_currency);
              } else {
                toast.success(resp.data.message);
                navigate('/', { state: { qr_login_completed: 1 } });
              }
              setConvertLoading(false);
            } catch (error) {
              toast.error(error.response?.data?.message || 'Conversion failed');
              setConvertLoading(false);
            }
          }
        }
      }
    }
    setConvertLoading(false);
  };

  // const getCurrencyFromConstants = (countryId) => {
  //   const code = currencyId[countryId];
  //   return {
  //     code: code || '',
  //     name: CURRENCIES[code] || code || '',
  //   };
  // };

  const getFlagUrl = (resp) => {
    switch (resp.currency) {
      case 'EUR':
        return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
      case 'RON':
        return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
      case 'DKK':
        return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
      case 'NOK':
        return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
      case 'SEK':
        return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
      case 'MYR':
        return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
      default:
        return `${Constants.FXMASTER_BASE_URL}flags/${resp?.meta?.flag?.split('/').pop()}`;
    }
  };
  initiateWalletTransaction
  useEffect(() => {
    beneficiaryList({ currencyid, setBeneficiaries });
  }, [currencyid]);

  const getClearbankBeneLocal = async (token, workspaceId) => {
    try {
      const encryptedPayload = await encryptPayload({
        workspace_id: workspaceId, platform: 'web',
        extraParamValidation: 'trustedfromweb'
      });
      const resp = await axios.post(
        Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );
      return resp.data.data.map((element) => ({
        id: element.id,
        display_name: element.beneficiaryName,
        bank_account_number: element.banks[0].accountNumber,
        country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
        code: element.banks[0].sortCode,
        bene_type: element.type,
        bank_type: 'clear_bank',
      }));
    } catch {
      return [];
    }
  };

  const getCCBeneLocal = async (token, workspaceId) => {
    try {
      const countryCodeMapping = {
        105: 'ifsc_code', 234: 'aba_number', 231: 'sort_code', 38: 'branch_code',
        13: 'bsb_number', 2: 'iban_number', 1: 'iban_number', 55: 'iban_number',
        114: 'iban_number', 115: 'iban_number', 129: 'iban_number', 158: 'iban_number',
        177: 'iban_number', 198: 'iban_number', 59: 'iban_number', 95: 'iban_number',
        100: 'iban_number', 193: 'iban_number', 249: 'iban_number',
      };
      const response = await axios.get(
        `${Constants.BASE_URL}API-FX-126-ListBeneficiary`,
        {
          params: { workspace_id: workspaceId, reference_type: 'money_transfer' },
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        },
      );
      return response.data.data
        .filter((el) => countryCodeMapping[el.meta.bank_country])
        .map((el) => ({
          id: el.id,
          display_name: el.display_name,
          bank_account_number: el.meta.bank_account_number || el.meta.iban,
          country_flag: el.country_flag,
          avatar: el.avatar || 'https://uat.fxmaster.co.uk/dist/images/user.png',
          code:
            el.meta.bic_number ?? el.meta.aba_number ?? el.meta.ifsc_code ??
            el.meta.sort_code ?? el.meta.branch_code ?? el.meta.bsb_number ??
            el.meta.routing_code_value_1,
          bank_code_type: el.meta.bank_code_type,
          type: el.type,
          country: el.meta.beneficiary_address,
          bank_account_name: el.meta.bank_account_name,
          bank_account_id: '',
          bene_type: el.type,
          bank_type: 'currency_cloud',
        }));
    } catch {
      return [];
    }
  };

  const handleRepeatTransaction = async (txn) => {
    try {
      const token = sessionStorage.getItem('login_token');
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      const staff_login_id = sessionStorage.getItem('staff_login_id');

      const conversionMeta = txn?.meta_data?.conversion_meta;
      const send_amount =
        conversionMeta?.conversion_client_sell_amount || txn?.amount;
      const sellCurrencyId =
        conversionMeta?.conversion_sell_currency === 'GBP' ? 231 : '';
      const buyCurrencyId =
        conversionMeta?.conversion_buy_currency === 'INR' ? 105 : '';
      const encryptedPayload = await encryptPayload({
        sell_currency_country_id: sellCurrencyId,
        buy_currency_country_id: buyCurrencyId,
        amount: parseFloat(parseFloat(send_amount).toFixed(2)),
        workspace_id: workspaceId,
        type: 'sell',
        staff_login_id: staff_login_id,
        key_name: 'individual_transaction_fee',
        domain: 1,
        platform: 'web',
        extraParamValidation: 'trustedfromweb'
      });
      const convResp = await axios.post(
        Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );

      const freshContactId = convResp.data.contact_id;


      if (!freshContactId) {
        toast.error('Could not get contact ID for repeat transaction.');
        return;
      }


      localStorage.setItem('repeat_contactId', freshContactId);

      let activeBeneficiaries = beneficiaries;


      if (!activeBeneficiaries || activeBeneficiaries.length === 0) {
        const clear = await getClearbankBeneLocal(token, workspaceId);
        const cc = await getCCBeneLocal(token, workspaceId);
        activeBeneficiaries = [...clear, ...cc];
        setBeneficiaries(activeBeneficiaries);
      }

      await initiateWalletTransaction({
        lastTransaction: txn,
        beneficiaries: activeBeneficiaries,
        currency: txn?.currency || 'GBP',
        currencyid: 231,
        navigate,
        ref: '',
        setButtonLoading,
        setcurrencyCloudBalance,
        setclearBankBalance,
        setclearBankConfiguration,
        toast,
      });
    } catch (err) {
      console.error('handleRepeatTransaction error:', err);
      toast.error(err?.response?.data?.message || 'Failed to prepare repeat transaction.');
    }
  };


  const effectiveRate =
    editExchangeRate !== '' ? parseFloat(editExchangeRate) : parseFloat(exchangeRate);


  const baseamount = amount && amount !== 0 ? amount : 1;
  console.log(baseamount);

  /* ─── inline styles matching Figma specs exactly ─── */

  // Rate pill: Hug×Hug, radius 8px, border 1px #E6E5E5, bg #FFFFFF,
  // padding 8 16 8 16, gap 16, horizontal flow
  const ratePillStyle = {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '16px',
    padding: '8px 16px',
    background: '#FFFFFF',
    border: '1px solid #E6E5E5',
    borderRadius: '8px',
  };

  const exchangeRateDisplayPillStyle = {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',   // Hug
    height: 'fit-content',  // Hug
    gap: '16px',
    padding: '8px 16px 8px 16px', // top 8, right 16, bottom 8, left 16
    border: '1px solid #E6E5E5',
    borderRadius: '8px',
    background: '#FFFFFF',
  };

  const bestRateDotStyle = {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: '#22c55e',
    display: 'inline-block',
    flexShrink: 0,
  };

  // Card wrapper: Fixed 672px wide, Hug height, radius 16px, border 1px #F3F2F2,
  // bg #FFFFFF, padding 24px, gap 16px, vertical flow
  const cardStyle = {
    background: '#FFFFFF',
    border: '1px solid #F3F2F2',
    borderRadius: '16px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    maxWidth: '672px',
    margin: '0 auto',
    boxSizing: 'border-box',
  };

  // Input row: Fill width, Fixed 56px height, radius 12px, border 1px #E2E6ED,
  // bg #FFFFFF, horizontal flow, space-between, padding 12 16
  const inputRowStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '56px',
    background: '#FFFFFF',
    border: '1px solid #E2E6ED',
    borderRadius: '12px',
    padding: '12px 16px',
    boxSizing: 'border-box',
    width: '100%',
    position: 'relative',
    overflow: 'visible',
  };

  // Continue button: Fill width, Fixed 56px height, radius 12px,
  // bg #D7D7D7 (inactive), padding 12 20, gap 16, horizontal flow
  const continueBtnStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    width: '100%',
    maxWidth: '672px',
    height: '56px',
    borderRadius: '12px',
    padding: '12px 20px',
    border: 'none',
    cursor: exchangeRate > 0 && !convertloading ? 'pointer' : 'not-allowed',
    boxSizing: 'border-box',
    fontSize: '15px',
    fontWeight: '600',
    transition: 'background 0.2s',
    margin: '0 auto',
  };

  const activeContinueBtnStyle = {
    ...continueBtnStyle,
    background: '#D26521',

    color: '#FFFFFF',
    cursor: 'pointer',
  };

  const inactiveContinueBtnStyle = {
    ...continueBtnStyle,
    background: '#D7D7D7',
    color: '#9CA3AF',
    cursor: 'not-allowed',
  };

  return (
    <div>
      <ToastContainer />
      {balLoading ? (
        <div className="text-center py-8">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      ) : (
        <div className="bg-gradient-to-b from-[#f8fafc] via-[#eff6ff4d] py-6 px-4">
          <div style={{ maxWidth: '672px', margin: '0 auto' }}>
            {/* Page title */}
            <h1 className="text-2xl font-semibold pm-cost-title text-center pb-4">
              Enter the amount you want to send
            </h1>

            {kycPendingLater && (
              <div style={{ maxWidth: '672px', margin: '0 auto 16px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                    background: '#ffffff',
                    border: '1px solid #ffffff',
                    borderRadius: '12px',
                    padding: '16px 20px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                    }}
                  >
                    <div
                      style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        background: '#FEF3C7',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        color: '#D97706',
                        fontWeight: 700,
                        fontSize: '16px',
                      }}
                    >
                      !
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: '14px',
                          fontWeight: 700,
                          color: '#1E2A3B',
                        }}
                      >
                        Verify your KYC to continue
                      </p>
                      <p
                        style={{
                          margin: '2px 0 0',
                          fontSize: '13px',
                          color: '#6B7280',
                        }}
                      >
                        You have completed your first transaction. Please verify
                        your KYC to make more transactions.
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() =>
                      navigate('/SumSubRegister', {
                        state: { phone: sessionStorage.getItem('login_phone') },
                      })
                    }
                    style={{
                      background: '#D9681D',
                      color: '#fff',
                      borderRadius: '10px',
                      padding: '10px 20px',
                      fontSize: '14px',
                      fontWeight: 600,
                      border: 'none',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                    }}
                  >
                    ✓ Verify KYC Now
                  </button>
                </div>
              </div>
            )}

            {/* ── Rate pill + Best Rate badge in one row, OUTSIDE the card ── */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginBottom: '12px',
                gap: '10px',
              }}
            >

              {exchangeRate > 0 && !convertloading && (
                <div style={exchangeRateDisplayPillStyle}>
                  <span
                    style={{
                      fontSize: '13px',
                      fontWeight: '600',
                      color: '#1E2A3B',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    1 GBP = {parseFloat(effectiveRate).toFixed(4)}{' '}
                    {receiveCurrencyValue}
                  </span>
                </div>
              )}

              {/* Rate pill */}
              <div style={ratePillStyle}>
                {exchangeRate > 0 && !convertloading && isStaffAllowed && (
                  <div className="flex items-center gap-2 font-medium text-[#1E2A3B]">
                    <span>1.00 GBP =</span>
                    <input
                      type="text"
                      inputMode="decimal"
                      min="0"
                      onKeyDown={(e) => {
                        if (
                          e.key === '-' ||
                          e.key === 'e' ||
                          e.key === 'ArrowUp' ||
                          e.key === 'ArrowDown'
                        )
                          e.preventDefault();
                      }}
                      value={
                        editExchangeRate !== ''
                          ? editExchangeRate
                          : parseFloat(exchangeRate).toFixed(4)
                      }
                      onChange={(e) => setEditExchangeRate(e.target.value)}
                      className="border border-[#DEDCE1] rounded px-2 py-0.5 text-[#252528] font-semibold text-sm w-28 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-400"
                    />
                    <span>{buyCurrency}</span>
                  </div>
                )}

                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px',
                    background: '#f0fdf4',
                    border: '1px solid #bbf7d0',
                    borderRadius: '999px',
                    padding: '3px 10px',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#15803d',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span style={bestRateDotStyle}></span>
                  Our Best Rate
                </span>
              </div>
            </div>

            {/* ── Main card ── */}
            <div style={cardStyle}>


              {/* You Send label */}
              <p
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#485D81',
                  margin: 0,
                }}
              >
                You Send
              </p>

              {/* You Send input row */}
              <div style={inputRowStyle}>
                {/* Left: currency symbol + amount input */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                    position: 'relative',
                    height: '100%',
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      left: 0,
                      fontSize: '15px',
                      color: '#252528',
                      fontWeight: '600',
                      pointerEvents: 'none',
                    }}
                  >
                    {currency ? getCurrencySymbol(currency) : '£'}
                  </span>
                  <input
                    value={amount}
                    type="text"
                    inputMode="decimal"
                    onKeyDown={(e) => {
                      if (
                        e.key === '-' ||
                        e.key === 'e' ||
                        e.key === 'ArrowUp' ||
                        e.key === 'ArrowDown'
                      )
                        e.preventDefault();
                    }}
                    placeholder="10.00"
                    style={{
                      paddingLeft: '42px',
                      width: '100%',
                      height: '100%',
                      fontSize: '15px',
                      fontWeight: '600',
                      color: '#252528',
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      const validated = value.match(/^\d*\.?\d{0,2}$/);
                      if (!validated) return;
                      setAmount(validated[0]);
                      if (e.target.value === '') {
                        clearTimeout(timeout.current);
                        setBuyAmount('');
                        setexchangeRate(0);
                        setBuyCurrency('');
                        setSellCurrency('');
                        setContactId('');
                        setTransferfee('');
                        setServicefee('');
                        return;
                      }
                      onChangeHandler(e.target.value);
                      setrecentEdit('sell');
                    }}
                  />
                </div>

                {/* Right: currency selector */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    paddingLeft: '12px',
                    borderLeft: '1px solid #E2E6ED',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={`${Constants.FXMASTER_BASE_URL}flags/UK.png`}
                    alt="GBP"
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                    }}
                  />
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#252528',
                    }}
                  >
                    GBP
                  </span>
                  <span style={{ color: '#9CA3AF', fontSize: '11px' }}>▾</span>


                </div>
              </div>

              {/* Swap icon divider */}
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <div
                  style={{ flex: 1, height: '1px', background: '#EBEBEB' }}
                ></div>
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    border: '1px solid #E2E6ED',
                    background: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#9CA3AF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="17 1 21 5 17 9"></polyline>
                    <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                    <polyline points="7 23 3 19 7 15"></polyline>
                    <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                  </svg>
                </div>
                <div
                  style={{ flex: 1, height: '1px', background: '#EBEBEB' }}
                ></div>
              </div>

              {/* Beneficiary Gets label */}
              <p
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#485D81',
                  margin: 0,
                }}
              >
                Beneficiary Gets
              </p>

              {/* Beneficiary Gets input row */}
              <div style={inputRowStyle}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flex: 1,
                    position: 'relative',
                    height: '100%',
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      left: 0,
                      fontSize: '15px',
                      color: '#252528',
                      fontWeight: '600',
                      pointerEvents: 'none',
                    }}
                  >
                    {receiveCurrencyValue
                      ? getCurrencySymbol(receiveCurrencyValue)
                      : '₹'}
                  </span>
                  <input
                    value={
                      editExchangeRate !== '' && amount
                        ? parseFloat(
                          amount * parseFloat(editExchangeRate),
                        ).toFixed(2)
                        : buyAmount
                    }
                    type="text"
                    inputMode="decimal"
                    onKeyDown={(e) => {
                      if (
                        e.key === '-' ||
                        e.key === 'e' ||
                        e.key === 'ArrowUp' ||
                        e.key === 'ArrowDown'
                      )
                        e.preventDefault();
                    }}
                    placeholder="1000.00"
                    readOnly={editExchangeRate !== ''}
                    style={{
                      paddingLeft: '38px',
                      width: '100%',
                      height: '100%',
                      fontSize: '15px',
                      fontWeight: '600',
                      color: '#252528',
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                    }}
                    onChange={(e) => {
                      if (editExchangeRate !== '') return;
                      const value = e.target.value;
                      if (value === '') {
                        clearTimeout(timeout.current);
                        setBuyAmount('');
                        setAmount('');
                        setexchangeRate(0);
                        setTransferfee('');
                        setServicefee('');
                        return;
                      }
                      if (value.startsWith('-')) return;
                      const validated = value.match(/^\d*\.?\d{0,2}$/);
                      if (!validated) return;
                      setBuyAmount(validated[0]);
                      onInverseChangeHandler(validated[0]);
                      setrecentEdit('buy');
                    }}
                  />
                </div>

                {/* Right: receive currency selector */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    paddingLeft: '12px',
                    borderLeft: '1px solid #E2E6ED',
                    cursor: 'pointer',
                    flexShrink: 0,
                    position: 'relative',
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setReceiveDropdownOpen(!receiveDropdownOpen);
                    setDropdownOpen(false);
                  }}
                >
                  {selectedReceiveCurrency ? (
                    <img
                      src={selectedReceiveCurrency.flag}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        flexShrink: 0,
                      }}
                      alt="flag"
                    />
                  ) : (
                    <img
                      src={`${Constants.FXMASTER_BASE_URL}flags/IN.PNG`}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                      }}
                      alt="flag"
                    />
                  )}
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#252528',
                    }}
                  >
                    {selectedReceiveCurrency
                      ? selectedReceiveCurrency.currency
                      : 'INR'}
                  </span>
                  <span style={{ color: '#9CA3AF', fontSize: '11px' }}>▾</span>

                  {receiveDropdownOpen && (
                    <div
                      style={{
                        ...dropdownStyle,
                        position: 'absolute',
                        zIndex: 50,
                        top: 'calc(100% + 8px)',
                        right: 0,
                        width: '200px',
                        border: '1.5px solid #1e3a6e',
                        background: '#fff',
                        boxShadow: '0 4px 16px rgba(11,33,78,0.12)',
                        borderRadius: '0.75rem',
                      }}
                    >

                      {countries.map((resp, index) => {
                        if (currency === resp.currency) return null;
                        const flagUrl = getCountryFlagUrl(resp);
                        const data = {
                          currency: resp.currency,
                          currencyid: resp?.id,
                          flag: flagUrl,
                        };
                        return (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 12px',
                              cursor: 'pointer',
                            }}
                            className="hover:bg-blue-50 transition-colors"
                            onClick={async (e) => {
                              e.preventDefault();
                              e.stopPropagation();

                              try {
                                const newReceiveCurrencyId =
                                  getCanonicalCountryId(resp?.id);

                                setReceiveDropdownOpen(false);
                                setSelectedReceiveCurrency(data);
                                setReceiveCurrency(newReceiveCurrencyId);
                                setReceiveCurrencyValue(resp.currency);

                                setEditExchangeRate('');

                                if (amount && parseFloat(amount) > 0) {
                                  clearTimeout(timeout.current);
                                  getConversionData(
                                    amount,
                                    newReceiveCurrencyId,
                                  );
                                }

                              } catch (err) {
                                console.error(
                                  'Error while changing receive currency:',
                                  err,
                                );
                              }
                            }}
                          >
                            <img
                              src={flagUrl}
                              alt="flag"
                              style={{
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                fontSize: '13px',
                                fontWeight: '600',
                                color: '#252528',
                                flexShrink: 0,
                              }}
                            >
                              {resp?.currency}
                            </span>
                            <span
                              style={{
                                fontSize: '12px',
                                color: '#94a3b8',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {resp?.name}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              {/* Loading spinner */}
              {convertloading && amount && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '16px 0',
                    gap: '8px',
                  }}
                >
                  <div className="w-6 h-6 border-2 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                  <p style={{ fontSize: '13px', color: '#6B7280', margin: 0 }}>
                    Fetching best rate...
                  </p>
                </div>
              )}

              {/* Transfer details */}
              {exchangeRate > 0 && amount && buyAmount && !convertloading && (
                <div
                  style={{
                    borderTop: '1px solid #EBEBEB',
                    paddingTop: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#1E2A3B',
                    }}
                  >
                    Transfer Details
                  </span>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                      You Send Amount
                    </span>
<span
                      className="pm-row"
                      style={{ fontWeight: '700', color: '#111827' }}
                    >
                      {parseFloat(amount).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{' '}
                      {displaySellCurrency}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                      Transfer Fee
                    </span>
                    <span
                      className="pm-row"
                      style={{
                        fontSize: '13px',
                        fontWeight: '500',
                        color: '#16a34a',
                      }}
                    >
                      {parseFloat(transferfee || 0).toFixed(2)}{' '}
                      {displaySellCurrency}{' '}
                    </span>
                  </div>
                  {isStaffAllowed && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                        Service Fee
                      </span>
                      <div
                        style={{
                          position: 'relative',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >

                        <input
                          value={servicefee}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setServicefee(value);
                          }}
                          placeholder="Enter Service Fee"
                          style={{
                            paddingLeft: '8px',
                            paddingRight: '8px',
                            width: '140px',
                            border: '1px solid #D1D5DB',
                            borderRadius: '6px',
                            padding: '4px 24px 4px 8px',
                            fontSize: '13px',
                          }}
                        />

                        <span
                          style={{
                            position: 'absolute',
                            fontWeight: 'bold',
                            right: '8px',
                            paddingLeft: '10px',
                            fontSize: '13px',
                            color: '#6B7280',
                          }}
                        >
                          {currency ? getCurrencySymbol(currency) : '£'}
                        </span>
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ fontSize: '13px', color: '#9CA3AF' }}>
                      Total To Pay
                    </span>
                    <span className="pm-row" style={{ fontSize: '13px' }}>

                      {(
                        (parseFloat(amount) || 0) +
                        (parseFloat(transferfee) || 0) +
                        (parseFloat(servicefee) || 0)
                      ).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{' '}
                      {displaySellCurrency}{' '}
                    </span>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        color: '#1E2A3B',
                      }}
                    >
                      Beneficiary Gets
                    </span>
                    <span
                      className="pm-row"
                      style={{ fontSize: '13px', fontWeight: '700' }}
                    >
                      {editExchangeRate !== '' && amount
                        ? parseFloat(
                          amount * parseFloat(editExchangeRate),
                        ).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : parseFloat(buyAmount).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{' '}
                      {displayReceiveCurrency}
                    </span>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ fontSize: '14px', color: '#676F7D' }}>
                      Exchange Rate
                    </span>
                    <span className="pm-row" style={{ fontSize: '13px' }}>
                      1.00 GBP ={' '}
                      <span style={{ fontWeight: '700', color: '#111827' }}>
                        {parseFloat(effectiveRate).toFixed(4)}{' '}
                        {receiveCurrencyValue}
                      </span>
                    </span>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                      }}
                    >
                      <svg
                        style={{
                          width: '16px',
                          height: '16px',
                          color: '#9CA3AF',
                        }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="12" cy="12" r="10" strokeWidth="2" />
                        <path d="M12 6v6l4 2" strokeWidth="2" />
                      </svg>
                      <span style={{ fontSize: '13px', color: '#6B7280' }}>
                        Estimate Delivery time
                      </span>
                    </div>
                    <span
                      className="pm-row"
                      style={{ fontSize: '13px', fontWeight: '500' }}
                    >
                      Same Day
                    </span>
                  </div>
                </div>
              )}

              {/* Note block (empty state) */}
              {!amount && !buyAmount && (
                <div
                  style={{
                    background: '#F9FAFB',
                    borderRadius: '12px',
                    padding: '16px',
                    border: '1px solid #EBEBEB',
                    display: 'flex',
                    gap: '12px',
                  }}
                >
                  <div
                    style={{
                      width: '28px',
                      height: '28px',
                      borderRadius: '8px',
                      background: '#FFFFFF',
                      border: '1px solid #DEDCE1',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '13px',
                      fontWeight: '700',
                      color: '#1E2A3B',
                      flexShrink: 0,
                    }}
                  >
                    i
                  </div>
                  <div>
                    <p
                      style={{
                        fontWeight: '600',
                        color: '#1E2A3B',
                        fontSize: '13px',
                        marginBottom: '4px',
                      }}
                    >
                      Note :
                    </p>
                    <p
                      style={{
                        color: '#1D2338',
                        fontSize: '13px',
                        margin: '2px 0',
                        fontFamily: 'Inter, sans-serif',
                      }}
                    >
                      Minimum transfer amount is 10
                    </p>
                    <p
                      style={{
                        color: '#1D2338',
                        fontSize: '13px',
                        margin: '2px 0',
                        fontFamily: 'Inter, sans-serif',
                      }}
                    >
                      Transfers must be initiated from your verified account.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Info banner below card */}

            {/* Continue button */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '16px',
                maxWidth: '672px',
                margin: '16px auto 0',
              }}
            >
              {exchangeRate !== 0 && !convertloading && showproceed ? (
                <button
                  type="button"
                  style={activeContinueBtnStyle}
                  className="hover:bg-orange-700 flex items-center justify-center gap-2"
                  disabled={loading}
                  onClick={() => {
                    const finalBuyAmount =
                      editExchangeRate !== '' && amount
                        ? parseFloat(
                          amount * parseFloat(editExchangeRate),
                        ).toFixed(2)
                        : buyAmount;

                    const finalExchangeRate =
                      editExchangeRate !== ''
                        ? parseFloat(editExchangeRate)
                        : exchangeRate;

                    navigate('/Choosepayment', {
                      state: {
                        currency: receiveCurrencyValue,
                        currencyid: receiveCurrency,
                        balance: receiveCurrencyValue
                          ? getAvailableBalance(receiveCurrencyValue).toLocaleString()
                          : '-',
                        buyAmount: finalBuyAmount,
                        exchangeRate: finalExchangeRate,
                        contactId,
                        from_currency: currency,
                        from_amount: amount,
                        transfer_fee: parseFloat(transferfee) || 0,
                        service_fee: parseFloat(servicefee) || 0,
                        total_amount: (
                          (parseFloat(amount) || 0) +
                          (parseFloat(transferfee) || 0) +
                          (parseFloat(servicefee) || 0)
                        ).toFixed(2),
                        sendmoney_Nav_node: 2,
                      },
                    });
                  }}
                >
                  {loading && (
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid rgba(255,255,255,0.4)',
                        borderTopColor: '#fff',
                        borderRadius: '50%',
                        animation: 'spin 0.7s linear infinite',
                      }}
                    />
                  )}

                  {loading ? 'Processing...' : 'Continue'}
                  <ArrowRight className="w-5 h-5 -ml-3" />
                </button>
              ) : (
                <button type="button" style={inactiveContinueBtnStyle} disabled>
                  <span className='inline-flex items-center gap-2'>
                    Continue <ArrowRight className="w-5 h-5 -ml-1" />
                  </span>
                </button>
              )}
            </div>
          </div>

          {/* Transaction History — full width, outside max-w container */}
          {lastTransactions?.some(
            (t) => t?.last_transaction?.type === 'debit',
          ) && (
              <div className="mt-6 border-t border-[#EBEBEB] pt-4">
                <TransactionHistory
                  lastTransactions={lastTransactions}
                  onRepeat={handleRepeatTransaction}
                  buttonLoading={buttonLoading}
                />
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default Sendmoneyflow;